import type { CourseMapRoot } from '@/components/CourseMap/coursemap.types';
import type { Json } from '@/lib/database.types';
import { supabase } from '@/lib/supabase';

const schoolId = import.meta.env.VITE_SCHOOL_ID;

const EMPTY_MAP: CourseMapRoot = {
	name: '',
	id: '',
	tracker: 'root',
	children: [],
};

export async function getCourseMap(): Promise<CourseMapRoot> {
	const { data, error } = await supabase
		.from('course_map')
		.select('course_map_jsonb')
		.eq('isDraft', false)
		.eq('school_id', schoolId)
		.maybeSingle();

	if (error) throw error;

	return (data?.course_map_jsonb as CourseMapRoot | null) ?? EMPTY_MAP;
}

export async function updateCourseMap(variables: { map: CourseMapRoot }) {
	const { map } = variables;

	// Try to update existing course_map
	const { data: updateData, error: updateError } = await supabase
		.from('course_map')
		.update({ course_map_jsonb: map as unknown as Json })
		.eq('isDraft', false)
		.eq('school_id', schoolId)
		.select();

	if (updateError) throw updateError;

	// If no rows updated, insert a new one
	if (!updateData || updateData.length === 0) {
		const { data: insertData, error: insertError } = await supabase
			.from('course_map')
			.insert({
				course_map_jsonb: map as unknown as Json,
				isDraft: false,
				school_id: schoolId,
			})
			.select();

		if (insertError) throw insertError;
		return insertData;
	}

	return updateData;
}

export async function deleteCourse(variables: { id: string }) {
	const { id } = variables;

	const { data, error } = await supabase
		.from('courses')
		.delete()
		.eq('course_id', id)
		.eq('school_id', schoolId);

	if (error) throw error;

	return data;
}
